// extracted by mini-css-extract-plugin
export default {"errorPageLayout":"errorPageLayout_errorPageLayout__pHseb","logo":"errorPageLayout_logo__SAdLP"};